import type { RouteRecordRaw } from 'vue-router'

export const countriesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/countries',
    name: 'COUNTRIES',
    component: () => import('./CountriesPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
